import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=643dd956&scoped=true&"
import script from "./Overview.js?vue&type=script&lang=js&"
export * from "./Overview.js?vue&type=script&lang=js&"
import style0 from "./Overview.css?vue&type=style&index=0&id=643dd956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643dd956",
  null
  
)

export default component.exports